/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RecordRead } from "../../models/record-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadRecord$Params {
  record_id: number;
  organisation_id: string;
  zone_id: string;
}

export function readRecord(
  http: HttpClient,
  rootUrl: string,
  params: ReadRecord$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecordRead>> {
  const rb = new RequestBuilder(rootUrl, readRecord.PATH, "get");
  if (params) {
    rb.path("record_id", params.record_id, {});
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("zone_id", params.zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecordRead>;
    }),
  );
}

readRecord.PATH = "/surfdomeinen/organisations/{organisation_id}/zones/{zone_id}/records/{record_id}";
